import { useState } from "react";
import { useSetRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { useNavigate } from "react-router-dom";
import { trackCapiStandardEvent } from "analytics/metaCapi";
import { PATH } from "routes/paths";
import {
  axiosInstanceV3,
  CustomResponseFormat,
  setBearerTokenV3,
} from "./axiosInstanceV3";
import useGtagConversion from "../../../hooks/useGtagConversion";
import useMixpanelProfileMkt from "../../../hooks/useMixpanelProfileMkt";
import mixpanel from "mixpanel-browser";
import useMixpanelMKT from "../../../hooks/useMixpanelMKT";

export default function useLoginV3({
  url,
  idToken,
  type,
  email,
}: {
  url: string;
  idToken: string;
  type: "google" | "apple";
  email?: string;
}) {
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const setUser = useSetRecoilState(userSimpleAtom);

  const trackGtagEvent = useGtagConversion();
  const trackMixpanel = useMixpanelMKT({ eventName: "가입", version: "v3" });
  const setMixpanelPeople = useMixpanelProfileMkt("v3");

  const login = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await axiosInstanceV3.post<CustomResponseFormat>(url, {
        idToken: idToken,
        type: type,
        ...(email && { email: email }),
      });

      if (response.code === 0) {
        const result = response.result;
        setBearerTokenV3(result.accessToken);
        setUser(result);

        trackCapiStandardEvent(
          "CompleteRegistration",
          {
            value: 0,
            currency: "KRW",
            externalId: result.userId,
            email: result.email,
          },
          undefined,
          "v3"
        );

        trackGtagEvent("CompleteRegistration", "v3");

        const mixpanelInstance = (mixpanel as any).v3;
        if (mixpanelInstance && result.trackId) {
          mixpanelInstance.identify(result.trackId);
          trackMixpanel();
          setMixpanelPeople({
            $email: result.email,
            user_id: result.userId,
          });
        }

        // nickname이 있으면 결제 페이지로, 없으면 닉네임 입력 페이지로
        if (result.nickname) {
          navigate(PATH.v3Payment, { replace: true });
        } else {
          navigate(PATH.v3NicknameSubmit, { replace: true });
        }
      }
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { login, isLoading };
}
